
import Vue from "vue";
import {
  background,
  text,
  accent,
  primary,
  border,
  subtext,
  muted,
  bordermuted,
} from "./constants/colors";
import Nav from "./components/Nav.vue";
import TitleRow from "@/components/TitleRow.vue";
import Sidebar from "@/components/Sidebar.vue";
import Notesbar from "@/components/Notesbar.vue";
import Footer from "@/components/Footer.vue";
import SocialBar from "@/components/SocialBar.vue";
import EmailBar from "@/components/EmailBar.vue";

export default Vue.extend({
  components: {
    Nav,
    TitleRow,
    Sidebar,
    Notesbar,
    Footer,
    SocialBar,
    EmailBar,
  },
  computed: {
    cssVars(): Record<string, unknown> {
      return {
        "--background": background,
        "--text": text,
        "--subtext": subtext,
        "--accent": accent,
        "--primary": primary,
        "--border": border,
        "--muted": muted,
        "--bordermuted": bordermuted,
        "--linkColor": this.selected === "notes" ? "#96d0ff" : text,
      };
    },
  },
  data() {
    return {
      selected: window.location.href.split("/")[4] || "home",
      selectedNote: "",
    };
  },
  methods: {
    sendToNotesPage(note: string) {
      this.selectedNote = note;
    },
  },
  watch: {
    $route(to) {
      this.selected = to.path.split("/")[1] || "home";
    },
  },
});
